/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
// @ts-expect-error TS(6133): 'React' is declared but its value is never read.
import React, { useRef } from "react";
import { cn } from "tailwind-variants";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import CommonModal from "common/vue/components/CommonModal.react.vue";
import { MAX_PRINT_SIZES_GROUPED } from "../common/constants";
import { getTitleCaseString } from "../utils";
import "./SizeGuide.scss";
import { renderList } from "common/vue/render-list";

export default function SizeGuide({ preset, onOnClose, ...restProps }: any) {
  const commonModalRef = useRef(null);

  function title() {
    return getTitleCaseString(preset);
  }

  function presetList() {
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    return MAX_PRINT_SIZES_GROUPED[preset];
  }

  function presetsGrouped() {
    const categoryMap = new Map();
    presetList().forEach(({ category, sizeRange, width, height }: any) => {
      const sizeObject = {
        sizeRange: sizeRange || null,
        sizeString: `${width}" x ${height}"`
      };
      if (!categoryMap.has(category)) {
        categoryMap.set(category, {
          category,
          sizes: []
        });
      }
      categoryMap.get(category).sizes.push(sizeObject);
    });
    return Array.from(categoryMap.values());
  }

  function getImageUrl(category: any) {
    return `https://jiffy.imgix.net/gen/preset-sizes/${preset}/${category}.png?ixlib=rb-0.3.5&h=400&dpr=2&q=60`;
  }

  function onClose() {
    onOnClose?.();
  }

  function closeModal() {
    // @ts-expect-error TS(2339): Property 'close' does not exist on type 'never'.
    commonModalRef.current?.close();
  }

  return (
    <CommonModal
      {...restProps}
      className="scope-873b6660"
      ref={commonModalRef}
      compact={true}
      hideCloseButton={true}
      bottomAligned={true}
      onOnClose={onClose}
      data-testid="common-modal"
    >
      <div className="size-guide scope-873b6660">
        <div className="size-guide__header scope-873b6660">
          <div className="size-guide__title-text scope-873b6660">{title()}</div>
          <button
            className="size-guide__close-button scope-873b6660"
            type="button"
            onClick={closeModal}
            data-testid="size-guide-close-button"
          >
            <UseSvg
              className="size-guide__close-button-icon scope-873b6660"
              icon="menu-close"
              data-testid="size-guide-close-button-icon"
            />
          </button>
        </div>
        <div className="size-guide__content scope-873b6660">
          {renderList(presetsGrouped(), (item, index) => (
            <div className="size-guide__item scope-873b6660" key={index}>
              <img
                className="size-guide__item-image scope-873b6660"
                src={getImageUrl(item.category)}
                alt="Size Guide"
              />
              <div className="size-guide__item-title scope-873b6660">{item.category}</div>
              <div
                className={cn("size-guide__item-sizes scope-873b6660", {
                  "size-guide__item-sizes--single": item.sizes.length === 1
                })}
              >
                {renderList(item.sizes, (size, sizeIndex) => (
                  <div className="size-guide__item-size scope-873b6660" key={sizeIndex}>
                    {size.sizeRange ? (
                      <strong className="scope-873b6660">{size.sizeRange}</strong>
                    ) : null}
                    <span className="scope-873b6660">{size.sizeString}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </CommonModal>
  );
}
